import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IssueTransactionMap } from '../../../globals';

@Component({
  selector: 'app-select-issue-transaction-attribute',
  templateUrl: './select-issue-transaction-attribute.component.html',
  styleUrls: ['./select-issue-transaction-attribute.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectIssueTransactionAttributeComponent),
      multi: true
    }
  ]
})
export class SelectIssueTransactionAttributeComponent implements ControlValueAccessor, OnDestroy, OnInit {

  @Input() appearance: 'fill' | 'outline' | 'standard' = 'fill';
  @Input() label: string = 'Vorgangstransaktionattribut wählen';
  @Input() multiple: boolean = false;

  formControl: FormControl = new FormControl();

  attributes = Object.keys(IssueTransactionMap).map(x => {
    return {
      'value': parseInt(x),
      'display': IssueTransactionMap[x].name
    };
  });

  private _subscriptions: Subscription[] = [];

  constructor() { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void { }

  public onTouched: () => void = () => { };
  registerOnTouched = (fn: any) => this.onTouched = fn;

  registerOnChange(fn: any): void {
    this._subscriptions.push(this.formControl.valueChanges.subscribe(fn));
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.formControl.disable() : this.formControl.enable();
  }

  writeValue(val: any): void {
    if (val) this.formControl.setValue(val);
  }

}
